import React from 'react';

export interface ITableEditContextState {
  enabled: boolean, // in view mode to don't show controls
  tempEditColumnIndex: number,
  setTempEditColumnIndex: any,
  doSelectCell: boolean,
  setDoSelectCell: any,
  editRowIndex: number,
  setEditRowIndex: (x: number) => void,
  editColumnIndex: number,
  setEditColumnIndex: (x: number) => void,
  deleteLine: (rowIndex: number) => boolean | Promise<boolean>,
  addLine: () => { setDataFunc: (data: any, focusRowIndex: number | undefined) => void, curListData: any, newData: any } | undefined,
  rowCount: number,
  data: Array<any>,
  rowRenderers: Array<any>,
  isCellLock: any,
  getCellData: any,
  getIndexOfFirstInvalidCell?: (rowIndex: number) => number | undefined,
  getIndexOfFirstInvalidCellAsync?: (rowIndex: number) => Promise<number | undefined>,
  canDeleteRow: ((rowIndex: number) => boolean) | undefined,
  canAdd: boolean | undefined,
  tableParentDivId: string,
  showTotalLineNum?: boolean,
  controlsAfterAddLineBtn: any,
  controlsBeforeAddLineBtn: any,
  lineSeqChange: ((seqUpDown: string, rowIndex: number) => void) | undefined,
  initializeFocusedCell: boolean | undefined,
  addRowOnArrowDownInSpecialCase: ((rowIndex?: number) => number) | undefined,
  shouldConfirmBeforeDelete: ((rowIndex: number) => boolean) | undefined,
  useTableSearch: boolean,
  tableColumnLength: number,
}

const defaultState: ITableEditContextState = {
  enabled: false,
  tempEditColumnIndex: -1,
  setTempEditColumnIndex: () => { },
  doSelectCell: false,
  setDoSelectCell: () => { },
  editRowIndex: -1,
  setEditRowIndex: () => { },
  editColumnIndex: -1,
  setEditColumnIndex: () => { },
  deleteLine: () => false,
  addLine: () => undefined,
  rowCount: 0,
  data: [],
  rowRenderers: [],
  isCellLock: undefined,
  getCellData: undefined,
  getIndexOfFirstInvalidCell: () => undefined,
  getIndexOfFirstInvalidCellAsync: () => Promise.resolve(undefined),
  canDeleteRow: undefined,
  canAdd: undefined,
  tableParentDivId: '',
  showTotalLineNum: false,
  controlsAfterAddLineBtn: null,
  controlsBeforeAddLineBtn: null,
  lineSeqChange: undefined,
  initializeFocusedCell: undefined,
  addRowOnArrowDownInSpecialCase: undefined,
  shouldConfirmBeforeDelete: undefined,
  useTableSearch: false,
  tableColumnLength: 0,
};

const TableEditContext = React.createContext<ITableEditContextState>(defaultState);

export default TableEditContext;
